import { px2mm } from "@/utils/size"
import { FlowsheetContent, NodeRecord } from "./services/modal"

export const FLOWSHEET_VERSION = 4;

const migrations = {
  1: (content: FlowsheetContent) => {
    return content;
  },
  2: (content: FlowsheetContent): FlowsheetContent => {
    const {sheets} = content;
    sheets.forEach((sheet) => {
      const {nodes, lines = []} = sheet;
      [...nodes, ...lines].forEach((node) => {
        if (node.tagOption) {
          const tagOption = (node as NodeRecord).tagOption
          tagOption!.size.width = px2mm(tagOption!.size.width)
          tagOption!.size.height = px2mm(tagOption!.size.height)
          tagOption!.offset.x = px2mm(tagOption!.offset.x)
          tagOption!.offset.y = px2mm(tagOption!.offset.y)
        }
      })
    })
    return {...content}
  },
  3: (content: FlowsheetContent): FlowsheetContent => {
    const {sheets} = content;
    sheets.forEach((sheet) => {
      const {nodes} = sheet;
      [...nodes].forEach((node) => {
        if (node.tagOption) {
          const tagOption = (node as NodeRecord).tagOption
          tagOption!.offset.x = 0
          tagOption!.offset.y = 0
        }
      })
    })
    return {...content}
  },
  4: (content: FlowsheetContent): FlowsheetContent => {
    const {sheets} = content;
    sheets.forEach((sheet) => {
      if ((sheet as any).overridedTextNodes) {
        sheet.overridedNodes = (sheet as any).overridedTextNodes
        delete (sheet as any).overridedTextNodes
      }
    })
    return {...content}
  }
}

export const doMigration = (content: FlowsheetContent) => {
  const curVersion = content.version || 0
  const updateList = Object.keys(migrations).filter(item => Number(item) > curVersion && Number(item) <= FLOWSHEET_VERSION);
  return updateList.reduce((newContent, key) => {
    return migrations[key](newContent)
  }, content)
}